import { Helmet as WHelmet } from 'react-helmet'

export const Helmet = WHelmet as any
